import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Typography } from '@material-ui/core';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Popover from '@mui/material/Popover';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/rootReducer';
import { logFirebaseEvent } from '../../firebase';
import { P2P_FD_VIEW } from '../../firebase/constant';
import PopUpDialogBox from '../../../../shared/PopUpDialogBox';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { getAuthToken } from '../../../../utils/localStorage';
import jwt from 'jwt-decode';
// import SemiCircleProgressBar from 'react-progressbar-semicircle';

const ExistingUser = (props: any) => {
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [totalEarning, setTotalEarning] = useState<any>(null);
  const [dialogOpen, setOpen] = useState<boolean>(false);
  const [user, setUser] = useState<any>(null);
  const [progress, setProgress] = useState<any>(0);
  const { dashboardSummary } = useSelector(
    (state: AppState) => state.dashboard
  );

  const { addMoney, withdrawMoney } = props;

  useEffect(() => {
    const token: any = getAuthToken();
    setUser(jwt(token)); // decode your token here
    logFirebaseEvent(P2P_FD_VIEW);
  }, []);

  useEffect(() => {
    if (dashboardSummary !== undefined || dashboardSummary !== null) {
      let progressBar: any = document.querySelector('.circular-progress');
      let valueContainer: any = document.querySelector('.value-container');
      const total: number = 1000000;
      const amountInvested: number =
        dashboardSummary?.data.TotalPrincipalInvestment;
      const portfolioValue: number = dashboardSummary?.data.CurrentValue;
      const earning = portfolioValue - amountInvested;
      setTotalEarning(earning);
      let progressValue: number = 0;
      let progressEndValue: number = Math.ceil(
        ((total - amountInvested - dashboardSummary?.data.RequestedInvestment) /
          total) *
          100
      );
      if (progressEndValue <= 0) {
        setDisableButton(true);
      }
      let speed: number = 50;
      for (let i = 1; i <= progressEndValue; i++) {
        let progress = setTimeout(() => {
          progressValue++;
          setProgress(progressValue);
          /* valueContainer.innerHTML = `${progressValue/10}L <span>available</span>`;
          progressBar.style.background = `conic-gradient(
              #ff0028 ${progressValue * 3.6 / 2}deg,
              #000099 ${progressValue * 3.6 / 2}deg
            )`; */
          if (progressValue == progressEndValue) {
            clearTimeout(progress);
          }
        }, i * speed);
      }
    }
  }, [dashboardSummary]);

  const getInfo = () => {
    console.log('get info');
  };
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleClose = () => {
    setOpen(!dialogOpen);
  };
  const handlePendingAmount = () => {
    setOpen(!dialogOpen);
  };

  const toTitleCase = (str: any) => {
    if (str !== undefined && str !== null) {
      return str.replace(/\w\S*/g, (txt: any) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }
  };

  return (
    <Card className='redBorder'>
      <CardContent>
        <Box className='exuBox'>
          <div className='text-name-style'>
            <Typography variant='h2'>
              Welcome &nbsp;
              <span>
                {user && toTitleCase(user?.full_name)?.split(' ')[0]}{' '}
              </span>
              {/*user?.full_name*/}
            </Typography>
          </div>
          {/* <Box className='halfCircle'>
            <SemiCircleProgressBar
              percentage={38}
              showPercentValue
              background='#000099'
              stroke='#ff0028'
              strokeWidth={22}
            />
            <Typography>avilable</Typography>
          </Box> */}
          <Grid container spacing={0} alignItems='center'>
            <Grid item xs={12}>
              {/* <div className='portfolio-container'>
                <div className='circular-progress'>
                  <div className='value-container'>0%</div>
                </div>
              </div> */}

              <Box className='progressSemiCircleMain'>
                <CircularProgress
                  variant='determinate'
                  value={50}
                  size='12rem'
                  thickness={5}
                />
              </Box>

              <Box className='progressSemiCircleValue'>
                <CircularProgress
                  variant='determinate'
                  value={progress / 2}
                  size='12rem'
                  thickness={5}
                />
                <p>
                  <span>{progress / 10}L</span> <br />{' '}
                  <span className='spanAvailable'> available</span>
                </p>
              </Box>
            </Grid>
            <Grid item xs={12} className='aiBox'>
            <Typography variant='h3'>Total amount invested</Typography>
              <Typography variant='h4'>
                <span className='fw-500 rupeeIcon'>₹</span>
                {Math.ceil(dashboardSummary?.data.TotalPrincipalInvestment + dashboardSummary?.data.RequestedInvestment)
                  .toFixed(0)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
              </Typography>
              <Typography variant='h3'>Amount allocated</Typography>
              <Typography variant='h4'>
                <span className='fw-500 rupeeIcon'>₹</span>
                {Math.ceil(dashboardSummary?.data.TotalPrincipalInvestment)
                  .toFixed(0)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
              </Typography>
              {dashboardSummary?.data.RequestedInvestment !== 0 &&
                <>
                  <Typography variant='h3'>
                  Pending allocation
                    <InfoOutlinedIcon onClick={handlePendingAmount} />
                  </Typography>
                  <Typography variant='h4'>
                    <span className='fw-500 rupeeIcon'>₹</span>
                    {Math.ceil(dashboardSummary?.data.RequestedInvestment)
                      .toFixed(0)
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                  </Typography>
                </>
              }
            </Grid>
          </Grid>
          <Box className='netRoi'>
            <Grid
              container
              spacing={0}
              alignItems='center'
              justifyContent='center'
            >
              <Grid item xs={7}>
                <Typography>net ROI</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography align='right'>
                  <strong>
                    {dashboardSummary?.data.annualizedReturn.toFixed(2)}%
                  </strong>
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={0} alignItems='center'>
              <Grid item xs={7}>
                <Typography>portfolio value</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography align='right'>
                  <strong>
                    <span className='rupeeIcon'>₹</span>
                    {Math.ceil(dashboardSummary?.data.CurrentValue)
                      .toFixed(0)
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                  </strong>
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={0} alignItems='center'>
              <Grid item xs={7}>
                <Typography>your earnings</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography
                  align='right'
                  className={
                    totalEarning > 0
                      ? 'totalProfit'
                      : totalEarning < 0
                      ? 'totalLoss'
                      : 'netAmount'
                  }
                >
                  <strong>
                    <span className='rupeeIcon'>₹</span>
                    {Math.round(totalEarning).toFixed(0)}
                  </strong>
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box className='moneyBtn'>
            <Grid
              container
              justifyContent='space-between'
              alignItems='center'
              spacing={2}
            >
              <Grid item xs={6}>
                <Button
                  variant='contained'
                  className='btnBlue small no-shadow fullWidth'
                  onClick={() => addMoney()}
                >
                  {' '}
                  {/**disabled = {disableButton}  */}
                  Add money
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant='contained'
                  className='btnBlue small no-shadow fullWidth'
                  onClick={() => withdrawMoney()}
                >
                  Withdraw money
                </Button>
              </Grid>
            </Grid>
          </Box>
          <PopUpDialogBox
            toggle={dialogOpen}
            handleClose={handleClose}
            title={true}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ExistingUser;
